import axios from 'axios'

const client = axios.create({
  withCredentials: true,
})

// client.defaults.baseURL = '/v1.0'
// client.defaults.baseURL =
//   process.env.REACT_APP_NODE_ENV === 'development' ? '/common' : 'https://wjdict-dev.wjthinkbig.com/common'
client.defaults.baseURL = '/common'

export default client
